import { useNotification } from '../../contexts/NotificationContext';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function NotificationBar() {
  const { message, isVisible, hideNotification } = useNotification();

  if (!isVisible) return null;

  return (
    <div className="bg-orange-600 text-white sticky top-0 z-50">
      <div className="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between flex-wrap">
          <div className="w-0 flex-1 flex items-center">
            <span className="flex p-2">
              <svg 
                className="h-5 w-5 text-white" 
                xmlns="http://www.w3.org/2000/svg" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" 
                />
              </svg>
            </span>
            <p className="ml-3 font-medium truncate">{message}</p>
          </div>
          <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
            <button
              type="button"
              className="-mr-1 flex p-2 rounded-md hover:bg-orange-500 focus:outline-none focus:ring-2 focus:ring-white sm:-mr-2 group"
              onClick={hideNotification}
              aria-label="Dismiss"
              title="Dismiss this announcement"
            >
              <span className="sr-only">Dismiss</span>
              <XMarkIcon className="h-6 w-6 text-white" aria-hidden="true" />
              <span className="absolute opacity-0 group-hover:opacity-100 -ml-20 -mt-2 bg-orange-700 text-white text-xs px-2 py-1 rounded pointer-events-none whitespace-nowrap transform -translate-y-full">
                Dismiss for me
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
} 